// Core-js is used to create polyfills for ES6 js methods.  It also create polyfills for some but NOT ALL webAPI methods.
// Set in .babelrc production object.
// Have the effect of making it difficult of splitting other adaptors into chunk files.

import { AnalyticsEvents } from './analytics_events.js';
import { CustomEvents } from './analytics_events.js';
import { AcquisioAdaptor } from './adaptors/adaptor_acquisio.js';
import { GoogleAdaptor } from './adaptors/adaptor_google.js';
import { IpromoteAdaptor } from './adaptors/adaptor_ipromote.js';
import { MixpanelAdaptor } from './adaptors/adaptor_mixpanel.js';
import { SessionAdaptor } from './adaptors/adaptor_session.js';

// Sets self as property of window object
// Invoked by script added into the html page
const sbAnalytics = (activeAdaptors) => {

  const addListenersToIframe = (iFrameEvent) => {
    let iframe = document.getElementById(iFrameEvent.detail.id);
    for (let eventListenerType of eventListenerTypes) {
      iframe.contentDocument.addEventListener(eventListenerType, () => handleEvent(event));
      testPayload.debugEventListeners.push({'eventType': eventListenerType, 'target': 'customListenerIframe'});
    }
  }

  const handleEvent = (event) => {
    if (DOMeventListenerTypes.includes(event.type)) {
      findAnalyticsEvent(event, activeAdaptors);
    } else {
      getCustomEvent(event.type);
    }
  }

  const getCustomEvent = (eventName) => {
    for (let customEvent in customEvents) {
      if (customEvents[customEvent].name === eventName) {
        adaptorsDecisionLoop(customEvents[customEvent], { type: eventName }, activeAdaptors);
        break;
      }
    }
  }

  const isAnalyticsTarget = ( event, analyticsEvent ) => {
    let targetElement = event.target;
    if (targetElement.matches(analyticsEvent.selector) && analyticsEvent.shouldTrack(targetElement, analyticsEvent.selector) ) {
      // link outgoing conditional here
      return targetElement;
    } else {
      targetElement = event.target.closest(analyticsEvent.selector);
      if (targetElement && analyticsEvent.shouldTrack(targetElement, analyticsEvent.selector) ) {
        return targetElement;
      }
    }
  }

  const findAnalyticsEvent = (event, activeAdaptors) => {
    // For development and manual testing this is the best place to intercept click events
    // will prevent submit events from firing
    // event.preventDefault();

    let targetElement = null;
    for (let analyticsEvent in analyticsEvents) {

      if (analyticsEvents[analyticsEvent].event === event.type && 
        (analyticsEvents[analyticsEvent].modes === activeAdaptors.mode ||
        analyticsEvents[analyticsEvent].modes === 'all') 
      ){
        targetElement = isAnalyticsTarget( event, analyticsEvents[analyticsEvent]);

        // Checks if adaptor has additional conditions.
        if ( targetElement ) {
          adaptorsDecisionLoop(analyticsEvents[analyticsEvent], event, activeAdaptors, targetElement);
          break;
        }

      }

    }

  }

  // When event is found it extracts data as specified by the event in analytics_events
  // then it iterates over adaptors specified in sbAnalytics({...}) object
  // contained in the script that is appended to html document body
  const adaptorsDecisionLoop = (analyticsEvent, event, activeAdaptors, targetElement) => {
    
    if (activeAdaptors.test === true) {
      testPayload.event = event;
      testPayload.analyticsEvent = analyticsEvent;
    }

    // Custom events should return an attribute value as a name if available
    if (analyticsEvent.category === "custom") {
      analyticsEvent.name = event.target.getAttribute('data-sb-custom-event') || analyticsEvent.name;
    }

    let adaptorPayload = {
      analyticsEvent: analyticsEvent,
      event: event,
      privateEventExtracts: {},
      publicEventExtracts: {},
      options: {},
      mode: activeAdaptors.mode,
      // If test property is not set, it adds it here
      test: activeAdaptors.test || false
    }

    let extractResults;

    if (analyticsEvent.extracts) {
      for (let extract in analyticsEvent.extracts) {
        extractResults = eventInformationExtractor(analyticsEvent, event, extract, targetElement);
        if ( extractResults.type === 'public' ) {
          adaptorPayload.publicEventExtracts[extractResults['key']] = extractResults['value']
        } else {
          adaptorPayload.privateEventExtracts[extractResults['key']] = extractResults['value']
        }
      }
    }

    for (let siteAdaptor of activeAdaptors.adaptors) {
      adaptorPayload.options[siteAdaptor.adaptor] = siteAdaptor.options;
      adaptorsDirectory[siteAdaptor.adaptor](adaptorPayload);
    }
    
  }

  const eventInformationExtractor = (analyticsEvent, event, extract, targetElement) => {
    let target = "";
    let key, value;

    switch (extract) {
      case 'elementAttribute':
        key = analyticsEvent.extracts[extract]['property'];
        value = targetElement.getAttribute(key)
        return { 'key': key, 'value': value, 'type': 'public' };
        break;
      case 'serializeForm':
        key = extract;
        value = serializeArray(event.target);
        return { 'key': key, 'value': value, 'type': 'private' };
        break;
      case 'serialize':
        key = extract;
        value = serialize(event.target);
        return { 'key': key, 'value': value, 'type': 'private' };
      default:
        console.log('No case is present in eventInformationExtractor for extract: ' + extract);
    }
  }

  // Replaces jquery serialize array
  // (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
  // https://vanillajstoolkit.com/helpers/serializearray/
  // might also be present in proxy form lead.
  const serializeArray = (form) => {

    var serialized = [];

    for (var i = 0; i < form.elements.length; i++) {
      var field = form.elements[i];
      if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue

      if (field.type === 'select-multiple') {
        for (var n = 0; n < field.options.length; n++) {
          if (!field.options[n].selected) continue;
          serialized.push({
            name: field.name,
            value: field.options[n].value
          });
        }
      } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
        serialized.push({
          name: field.name,
          value: field.value
        });
      }
    }

    return serialized;

  };

// https://gomakethings.com/how-to-serialize-form-data-with-vanilla-js/
// Serialize all form data into a query string
// (c) 2018 Chris Ferdinandi, MIT License, https://gomakethings.com
  const serialize = (form) => {

    var serialized = [];

    for (var i = 0; i < form.elements.length; i++) {
      var field = form.elements[i];
      if (!field.name || field.disabled || field.type === 'file' || field.type === 'reset' || field.type === 'submit' || field.type === 'button') continue;

      if (field.type === 'select-multiple') {
        for (var n = 0; n < field.options.length; n++) {
          if (!field.options[n].selected) continue;
          serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.options[n].value));
        }
      } else if ((field.type !== 'checkbox' && field.type !== 'radio') || field.checked) {
        serialized.push(encodeURIComponent(field.name) + "=" + encodeURIComponent(field.value));
      }
    }

    return serialized.join('&');

  };

  // Working code starts here.
  const testPayload = {
    debugEventListeners: [],
    event: null,
    analyticsEvent: null
  }

  // This logic supports prepended analytics events that can follow the same logic as those defined
  // in analytics_events.js. But these events can be configured outside on jsanalytics via the HTML template.
  // This is used by partners to implement custom events globally across all pages in their template/instance.
  const otherEvents = window.sbAnalyticsCustomEvents ? window.sbAnalyticsCustomEvents : [];
  const analyticsEvents = otherEvents.concat(AnalyticsEvents);
  const customEvents = CustomEvents;
  const acquisioAdaptor = AcquisioAdaptor;
  const googleAdaptor = GoogleAdaptor;
  const ipromoteAdaptor = IpromoteAdaptor;
  const mixpanelAdaptor = MixpanelAdaptor;
  const sessionAdaptor = SessionAdaptor;
  // Can not directly set properties to import command, must use intermediary constant variable

  const adaptorsDirectory = {
    acquisio: acquisioAdaptor,
    ga: googleAdaptor,
    ipromote: ipromoteAdaptor,
    mixpanel: mixpanelAdaptor,
    session: sessionAdaptor
  }

  let analyticsEventSelectors = [];

  // Event Listeners
  // Event Listeners follow a concept of event delegation.
  // Listeners are set to the document body and the body of any iframes and then sorted when triggered.
  // Listeners are not set specific target elements

  // Whether an event is trackable is determined in analytics_events.js
  const DOMeventListenerTypes = ['click', 'submit'];
  // DOMeventListenerTypes is used to determine how an event is handled.
  // Custom event listeners are be appended to the array eventListenerTypes to set listeners on page
  const eventListenerTypes = ['click', 'submit'];

  for (let customEvent in customEvents ){
    // At a later point, this should contain a should bind function.
    eventListenerTypes.push(customEvents[customEvent].name);
  }

  // Set Event Listeners
  // Multiple events can fire from the same action
  // If a submit button is clicked it will trigger both a click and a submit event
  // Trigger based on order in eventListenerTypes array (click will occur before submit)
  for (let eventListenerType of eventListenerTypes) {
    document.addEventListener(eventListenerType, () => handleEvent(event));
  }

  // Iframes must have their own event listeners
  // The general listeners applied to document will not detect events in an iframe
  // Listeners will cease operation by a .write() method,
  // or anything that destroys the element it is attached to

  /**disabling iframe event binding until tested
  let iframes = document.getElementsByTagName('iframe');

  if (iframes.length) {
    for (let iframe of iframes) {
      for (let eventListenerType of eventListenerTypes) {
        // Listeners are tested by creating a payload object specifically for the test file
        // This was done under the impression it is currently not possible to test for the existence of event listeners in jest or jsdom.
        // At one point this true, but it might not be currently true with Jest and jsdom.
        if (activeAdaptors.test === true) {
          testPayload.debugEventListeners.push({'eventType': eventListenerType, 'target': 'iframe'});
        }
        iframe.contentDocument.addEventListener(eventListenerType, () => handleEvent(event));
      }
    }
  }
  **/

  // Use attachEvent instead of addEventListener for IE 9 possibly IE 11 and sooner? in analytics_base.coffee
  // https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener

  // Trigger site page view automatically
  if (activeAdaptors.test == false) {
    getCustomEvent('site-page-view');
  }

  // Move all event selectors into an array
  for ( let analyticsEvent in analyticsEvents ) {
    analyticsEventSelectors.push( analyticsEvents[analyticsEvent].selector );
  }

  // When Iframe is add the custom event below must be triggered to call the function below
  // This does not appear to be testable.
  // Jest can not emulate events, but some testing suites like Enzyme for React can

  // POST IE10 SUPPORT
  // Due to IE10 support mutation observers are not yet usable
  // When IE11 is the greatest extent of backwards compatablity this custom listener should be replaced with a mutationObserver
  // https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver
  // https://developer.mozilla.org/en-US/docs/Web/API/MutationObserver/MutationObserver

  /**disabling iframe event binding for now until tested
  document.addEventListener('addIFrameEvent', () => addListenersToIframe(iFrameEvent));
  **/
  if (activeAdaptors.test === true) {
    window.sbAnalytics = {
      testPayload: testPayload,
    }
  }
}

const analytics = {
  sbAnalytics,
}

export default analytics;
